import { BackgroundMedia } from './background-media.model';
import { Css } from './css.model';
import { Margin } from './margin.model';
import { Padding } from './padding.model';

export class Page {
  Color: string = '';
  BackgroundColor?: string;
  MarginTop?: string;
  MarginRight?: string;
  MarginBottom?: string;
  MarginLeft?: string;
  PaddingTop?: string;
  PaddingRight?: string;
  PaddingBottom?: string;
  PaddingLeft?: string;
  // Margin: Margin = new Margin();
  // Padding: Padding = new Padding();
  BackgroundMedia?: BackgroundMedia;
  FullWidth: boolean = false;
  Css?: Css;
  Styles?: string[];
}
